import styles from './styles/TalkToUs.css'
import Header from '../typography/Header'
import P from '../typography/Paragraph'
import Button from '../forms/Button'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toggleModal } from '../../store/ui/actions'
import { setMode } from '../../store/login-modal/actions'
import classNames from 'classnames'

const TalkToUs = ({ join, header = true, pricingTab = 'individuals', contactCopy = 'Book a demo', subheader, cta }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const handleJoin = (e) => {
    dispatch(setMode('register'))
    dispatch(toggleModal('login', true))
  }
  return (
    <div className={styles.layout}>
      {header && (
        <Header className={styles.header} level={3}>Do better research</Header>
      )}
      {join
        ? (
          <>
            <P className={styles.subheader}>Join scite to be a part of a community dedicated to making science more reliable.</P>
            <div className={styles.btnGroup}>
              <a target='_blank' rel='noopener noreferrer' href={CONFIG.trialFormURL}>
                <Button className={styles.submitBtn} color='white'>Book a demo</Button>
              </a>
              <Button className={classNames(styles.submitBtn, styles.transparentBtn)} onClick={handleJoin} color='transparent'>Join now <i className={`icon icon-right-arrow ${styles.arrowImg}`} /></Button>
            </div>
          </>
          )
        : (
          <>
            <P className={styles.subheader}>{subheader || 'Get in touch with our team to learn more about how scite can help you better discover and understand research'}</P>
            <div className={styles.btnGroup}>
              <a target='_blank' rel='noopener noreferrer' href={CONFIG.trialFormURL}>
                <Button className={styles.submitBtn} color='white'>{contactCopy}<i className={`icon icon-right-arrow ${styles.arrowImg}`} /></Button>
              </a>
              {cta || (
                <Button className={classNames(styles.submitBtn, styles.transparentBtn)} onClick={() => history.push(`/pricing?tab=${pricingTab}`)} color='transparent'>View pricing</Button>
              )}
            </div>
          </>
          )}
    </div>
  )
}

export default TalkToUs
